import { useQuery } from 'react-query';
import { getProductReservationApi } from '../../../../config/SwaggerProductReservationApi';
import configQueryReactSimpleRequest from '../../config/configQuery';

const useDeelProjectsQueryFn = () =>
    getProductReservationApi().deelproject.deelprojectList()
        .then((response) => response.data);

const useDeelProjectsQuery = () => {
    const deelProjectsQuery = useQuery(['deelproject'], useDeelProjectsQueryFn, configQueryReactSimpleRequest);

    return deelProjectsQuery;
};

export default useDeelProjectsQuery;
